// extracted by mini-css-extract-plugin
module.exports = {"advert":"_1vQ-N","advertImg":"_28ykl"};